import React , {useState , useEffect } from 'react';
import './OrderPage.css';
import Footer from '../components/Footer';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import {  doc, getDoc , db , deleteDoc } from '../firebase';
import { useParams , useNavigate } from 'react-router-dom';



const OrderPage = () => {

    let navigate = useNavigate();

  let { orderId } = useParams();

  const openInNewTab = url => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  const [orderObject , setOrderObject] = useState({});
  const [priceValue , setPriceValue ] = useState(0);
  const [loading , setLoading] = useState(false);

  const totalPrice = (array) => {
    const prices = array.map((item) => parseInt(item.price));
    let totalValue  = prices.reduce((a, b) => a + b);
    setPriceValue(totalValue);
  };


  useEffect(() => {

    window.scrollTo(0,0);
    
    const getOrderFromFireStore = async () => {
      const docRef = doc(db, "orders", orderId );
const docSnap = await getDoc(docRef);

if (docSnap.exists()) {
 
  setOrderObject(docSnap.data());
  totalPrice(docSnap.data().orders);
} else {

  setOrderObject(null)
}


    }
    getOrderFromFireStore();

  } , []);


  const removeOrder = async () => {
    setLoading(true);
    await deleteDoc(doc(db, "orders", orderId));
    
    setTimeout(() => {
      setLoading(false);
    }, 900);

    setTimeout(() => {
      navigate('/');
    }, 1100);
  
  }

  return (
    <div className="main_homepage" >

    
    <NavbarHome />

<div className="container-mid">

<div className="section most_features_section ">

<img src="/images/icons/logo.png" alt="" className="identity_logo" />
<div className="d-flex-c ">

<div className="info_box"></div>
<h1 className="main_headline">  شكرا لاختيارك البوصة السياحية </h1>
</div>

<p className="main_para mt-1"> من خلال هذه الصفحة يمكنك متابعة تفاصيل وحالة طلبك ’ لا تتردد في حال وجود اي استفسار او شكوى بالتواصل معنا مباشرة </p>


</div>

<div className="section date_section">
  

<div className="d-flex-c mt-5">

<div className="info_box"></div>
<h1 className="main_headline"> تاريخ الرحلة: {orderObject.date}</h1>
</div>

</div>

<div className="section order_summary ">


<div className="d-flex-c mt-5">

<div className="info_box"></div>
<h1 className="main_headline">  ملخص طلبك </h1>
</div>




    {orderObject.orders && orderObject.orders.map(( {  price , name , service_provider , image , status } ) => (
      <div className="grid_order ordering_div mt-2">
    

    <div className="package_info_order d-flex-c">

        <img src={image} alt="" className='order_small_card_img' />

        <div className="order_info">
        <h1 className="location_slidetwo_headline"> {name}  </h1>
        <button className="btn_category mt-1"> {service_provider} </button>
        </div>
        

    </div>

    <div className="package_price_order">
        <h1 className="headline_info"> السعر </h1>
        <h1 className="headline_info span_bold"> {price} ريال </h1>
    </div>

    {status === 'wait-payment' && (
      <div className="package_status_order text-center">
      <img src="/images/icons/time-is-money.png" alt="" className="" />
      <h1 className="headline_info span_bold">  بانتظار الدفع  </h1>
    </div>
    )}

    {status === 'in-progress' && (
      <div className="package_status_order text-center">
      <img src="/images/icons/effective.png" alt="" className="" />
      <h1 className="headline_info span_bold">   تحت المعالجة </h1>
    </div>
    )}

    {status === 'confirmed' && (
      <div className="package_status_order text-center">
      <img src="/images/icons/success.png" alt="" className="" />
      <h1 className="headline_info span_bold">  تم التأكيد </h1>
    </div>
    )}

    {status === 'cancelled' && (
      <div className="package_status_order text-center">
      <img src="/images/icons/remove.png" alt="" className="" />
      <h1 className="headline_info span_bold">  تم الالغاء </h1>
    </div>
    )}




    </div>
    )) }







</div>

    <div className="section total_order_summary">

    <div className="d-flex-c mt-5">

<div className="info_box"></div>
<h1 className="main_headline">   المجموع </h1>
</div>

    
    <div className="grid_order_summary">

    <div className="panel_carts">



<div className="d-flex-c f-sp">
<p className="main_para"> مجموع المنتجات شامل ضريبة القيمة المضافة </p>
<p className="main_para ">SAR {priceValue}</p> 

 </div>

<div className="d-flex-c f-sp">
<h4 className='main_para' >المجموع الكلي</h4>
<h4 className='main_para bg_green p-2' >SAR {priceValue}</h4>

 </div>


</div>

  <div className="panel_btns">

  {/* <button className="btn_category w-100 mt-1 bg_purple d-flex-c f-sv" > 
  <span>     اتمام الدفع  </span>
    <img src="/images/icons/credit-card.png" alt="" className="icon_smaller" />
 
   </button> */}

    <button className="btn_category w-100 mt-1 d-flex-c f-sv" onClick={() => openInNewTab('https://wa.me/966501057512')} > 
    <span>    تواصل معنا على الواتس  </span>
    <img src="/images/icons/whatsapp.png" alt="" className="icon_smaller" />
  
    </button>

    {/* <button className="btn_category w-100 mt-1 bg_green d-flex-c f-sv">  
      <span>  تحميل ملف الرحلة </span>
    <img src="/images/icons/travel-guide.png" alt="" className="icon_smaller" />
     </button>
    
    <button className="btn_category w-100 mt-1 bg_purple d-flex-c f-sv">  
      <span> اضافة للتقويم </span>
    <img src="/images/icons/calendar.png" alt="" className="icon_smaller" />
     </button> */}

  


  </div>

    </div>



    </div>

    <div className="section happy_vacation ">

   <div className="grid_vaction">

   <div className="info_div">

   <div className="d-flex-c mt-5">

<div className="info_box"></div>
<h1 className="main_headline">   نتمنى لك رحلة سعيدة </h1>
</div>
    <p className="main_para mt-1"> نشكر لك اختيارك البوصلة السياحية لرحلتك ونتمنى ان تستمتع معنا بالرحلة </p>

   </div>

    <div className="barcode_div">
    <img src="/images/icons/qr_code.png" alt="" /> <br /><br />
    <a className="btn_category bg_purple mt-1 p-3" href="/images/icons/qr_code.png" download > تحميل الباركود  </a>
   
    </div>


   </div>




    </div>

    <div className="section cancel_order">


    {loading ? (
              <>
                                <img src="/images/icons/loading-spinner.gif" className='loading_spinner' alt="" />
                            </>
            ) : (
              <button  className="mt-1 btn_pricing mx-2 bg_red w-100" onClick={() => removeOrder() }  > ❌  الغاء الطلب   </button> 
            )}

    </div>

</div>







    <Footer />

    </div>
  )
}

export default OrderPage